import { InsuranceEntryState, insuranceMachineV2 } from 'domains/signupv2/Insurance/insuranceMachineV2';
import { isArray } from 'lodash';
import { createActorContextFromActor } from 'utils/xstate/context';

export const InsuranceContextV2 = createActorContextFromActor<typeof insuranceMachineV2>();

export const withInsuranceMachineStateV2 = (
  Component: React.FC,
  matchingState: InsuranceEntryState | InsuranceEntryState[],
) => {
  return (props: Record<string, unknown>) => {
    const matchesState = InsuranceContextV2.useSelector(state => {
      if (isArray(matchingState) && matchingState.some(s => state.matches(s))) {
        return true;
      }

      if (state.matches(matchingState as InsuranceEntryState)) {
        return true;
      }

      return false;
    });

    if (matchesState) {
      return <Component {...props} />;
    }
    return null;
  };
};
